import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allDisabilityMapping : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.MAP_DISABILITY_NEXT_STEP: 
          return {...state,currentStep : state.currentStep + 1};
        case actionTypes.MAP_DISABILITY_PREVIOUS_STEP :
          return {...state,currentStep : state.currentStep - 1};
        case actionTypes.MAP_DISABILITY_UPLOAD_FILE_SUCCESS :
        return {...state, allColumns : action.val.columns, rowData : action.val.data, file: action.val.file};
        case actionTypes.MAP_DISABILITY_MATCH_COLUMN_SUCCESS :
        return {...state, matchedColumn : action.val};
        case actionTypes.MAP_DISABILITY_SAVE_DISABILITY_MAPPING :
          return {...state, allDisabilityMapping : action.val};
        default:
          break;
    }
    return state;
}